import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-angle-double-left-icon',
  templateUrl: './navigation-angle-double-left.component.html'
})
export class NavigationAngleDoubleLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
